import appLogo from "@/assets/images/app-logo.png";
import { AppBranding } from "@/config/branding";
import { useAuth } from "@/contexts/AuthContext";
import { useT } from "@/i18n";
import { Link } from "@tanstack/react-router";
import { HiMenu, HiOutlineLogout } from "react-icons/hi";
import { AppButton } from "./AppButton";
import { LocalePicker } from "./LocalePicker";

/** The teacher area's top bar: the way home, who you are, and the way out — on every page. */
export function TeacherNavbar({ width, onOpenMenu }: { width: string; onOpenMenu: () => void }) {
  const { user, signOut } = useAuth();
  const t = useT();

  return (
    <header className="sticky top-0 z-20 border-b border-gray-100 bg-white shadow-card-light">
      <div className={`mx-auto flex items-center justify-between gap-3 px-4 py-3 sm:px-6 ${width}`}>
        <button
          type="button"
          aria-label={t["nav.openMenu"]}
          onClick={onOpenMenu}
          className="-ml-1 shrink-0 rounded-full p-2 text-app-ink hover:bg-app-sky-soft lg:hidden"
        >
          <HiMenu className="h-6 w-6" aria-hidden="true" />
        </button>

        <Link to="/teacher" className="flex min-w-0 flex-1 items-center gap-2.5 lg:flex-none">
          <img src={appLogo} alt="" className="h-9 w-auto rounded-xl" />
          <span className="truncate font-kumbh text-base font-extrabold text-app-ink">
            {AppBranding.name}
          </span>
        </Link>

        <div className="flex shrink-0 items-center gap-3">
          {user?.name && <span className="app-value hidden sm:block">{user.name}</span>}
          <LocalePicker />
          <AppButton tone="quiet" size="sm" onClick={() => void signOut()}>
            <HiOutlineLogout className="h-4 w-4" aria-hidden="true" />
            {t["nav.signOut"]}
          </AppButton>
        </div>
      </div>
    </header>
  );
}
